/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import styles from '../styles/Home.module.css';
import { useEffect, useState } from 'react';
import { CallbackType,FRAuth,  FRLoginFailure, FRLoginSuccess, FRStep, StepType } from '@forgerock/javascript-sdk';
import Loading from '../components/02-molecules/Loading';
import { trees } from '../config';
import { IStageProgressBadge, StageProgressBadge } from '../components/layout/StageProgressBadge';
import FROutputCallbackBasedView from '../components/forms/common/FROutputCallBackBasedView';
import SuspendMessage from '../components/forms/common/SuspendMessage.tsx';
// import { cloneDeep, isEmpty, isNil } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { getInitialStageItems, getStageHeader } from '../util/generalUtility';
import SelectMFAMethod from '../components/forms/Login/selectMFAMethod';
import RegisterAppQR from '../components/forms/Login/registerAppQR';
import ValidateCode from '../components/forms/common/ValidateCode';
import FormLayout from '../components/layout/form';
import { MessageType } from '../components/modals/SuccessErrorModal';
import { useNavigate } from 'react-router-dom';
import LoginStyles from '../styles/LoginHelp.module.css';
import { configOptions } from '../config/index';

const ResetPasswordPage = () => {
    const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);
    const [tree, setTree] = useState(trees.PasswordReset);
    const [stageItems, setStageItems] = useState<IStageProgressBadge[]>([]);
    const[stageHeaderList,setStageHeaderList] = useState<{name:string,stageName:string}[]>([])
    const [messageType, setMessageType] = useState(MessageType.info);
    const [message, setMessage] = useState('');  
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [goto, setGoto] = useState('');
    const [redirectUI, setRedirectUI] = useState('')

    const navigate = useNavigate();
  
  const redirectHandle=(initialStep:FRStep | FRLoginFailure | FRLoginSuccess) => {
    if(initialStep && initialStep.type===StepType.Step){
      let email =''
      const meta = initialStep.getCallbacksOfType(CallbackType.MetadataCallback)
      if(!!meta && meta.length){
          email = (meta[0].getOutputValue('data') as any)['email'] as string;
      }
      initialStep.callbacks.forEach((callback, i) => {  
        const type = callback.getType()  
       if (type === CallbackType.RedirectCallback) {
    
      if (callback.getOutputValue('trackingCookie')) {
        // save current step information for later resumption of tree.
        sessionStorage.setItem('authIndexValue', tree);
        sessionStorage.setItem('step', JSON.stringify(initialStep));
        sessionStorage.setItem('realm', 'PnW');
        localStorage.setItem(FRAuth.previousStepKey, JSON.stringify(initialStep))
      }
      const redirectUrl = callback.getOutputValue('redirectUrl') as string;
      if (callback.getOutputValue('redirectMethod') === 'POST') {
        const redirectData = callback.getOutputValue('redirectData') as string;
        const form = document.createElement('form');
        form.method = 'post';
        form.action = redirectUrl ;

        Object.entries(redirectData as string).forEach(([key, value]) => {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = value;

          form.appendChild(hiddenField);
        });
        const loginHint = document.createElement('input');
        loginHint.type = 'hidden';
        loginHint.name = "login_hint";
        loginHint.value = email;
        form.appendChild(loginHint);
        document.body.appendChild(form);
        form.submit();
      } else {
        let loginHintRedirectURI= redirectUrl+'&login_hint='+email
        let loginHintUrlStep = cloneDeep(initialStep); 

        loginHintUrlStep.callbacks.map((callback) => {
          if (callback.getType() === CallbackType.RedirectCallback) {
            callback.payload.output.map((values) => {
              if (values.name == "redirectUrl") {
                values.value = loginHintRedirectURI;
              }
            });
          }
        });
       FRAuth.redirect(loginHintUrlStep as FRStep);
      }
      return;
    }
  })
    }
  }

    useEffect(() => {
      (async function getStep() {
      setGoto(new URLSearchParams(window.location.search).get('goto') || '')
/*       let goto = new URLSearchParams(window.location.search).get('goto') || ''
      const stepString = sessionStorage.getItem('step')
      const code = sessionStorage.getItem('mfacode')
      const state = sessionStorage.getItem('mfastate') */
/*       let step;
      if(!!stepString){
          step =JSON.parse(stepString).payload;
      } */
      setRedirectUI(new URLSearchParams(window.location.search).get('redirectUi') || '')
        // const goto = new URLSearchParams(window.location.search).get('goto') || '';
      // if(!!!step){
        try {
       
          
            const initialStep = await FRAuth.start({ tree, query: {goto} });
          if(initialStep && initialStep.type===StepType.Step){
            setStageHeaderList(getStageHeader(initialStep));
            setStageItems(getInitialStageItems(initialStep,getStageHeader(initialStep)));
          }
          setStep(initialStep);
        } catch (err) {
          console.error(`Error: request for initial step; ${err}`);
        }
     /*  } else{
        if(!!code && !!state){
          let queryParam;
          if (goto && goto != null && goto != '' && goto != undefined) {
              queryParam = '&code='+code+'&state='+state+'&authIndexValue='+tree
          }else{
            queryParam = '?code='+code+'&state='+state+'&authIndexValue='+tree
          }
          const nextStep= await FRAuth.resume(window.location.href+queryParam)
          
          setStep(nextStep);
        }
      } */
    })();

    return () => {
        sessionStorage.removeItem('mfacode');
        sessionStorage.removeItem('mfastate');
        sessionStorage.removeItem('step');
    };

    }, []);
  
    useEffect(() => {
      if(!isNil(step) && step && step.type === StepType.Step)
        updateStageItems(step.getStage())      
  },[step]);
  
    const updateStageItems =(stage: string | undefined) => {
      const stageItemForUpdate = cloneDeep(stageItems);
      if(step && step.type===StepType.Step){
        stageHeaderList?.forEach((value:{name:string,stageName:string},index:number)=>{
          if(stageItemForUpdate[index].className==='active'){
            stageItemForUpdate[index].className='completed';
          }
            if(stage===value.stageName){
              stageItemForUpdate[index].className='active';
            }
            
        })
        // This logic is for back button clicks 
      stageItemForUpdate?.reverse().every((v:any,index:number)=>{
        if (stageItemForUpdate[index].className==='disabled')
        {
          return true;
        } else if(stageItemForUpdate[index].className==='active')
        {
          return false;
        }
        else if(stageItemForUpdate[index].className==='completed')
        {
          stageItemForUpdate[index].className='disabled'
          return true;
        }
    })
      }
      // setStageItems(stageItemForUpdate);
      let stageItemForUpdatefinal=stageItemForUpdate.reverse();
      setStageItems(stageItemForUpdatefinal);
    }
  
  
    const getContinueRegistrationView = () => {
      let uiElement: JSX.Element = <Loading size={100} />;
      if (step && step.type === StepType.Step) {
        switch (step.getStage()) {
          case 'ResetPassword':  
          case 'GetEmail':
            uiElement = <> <StageProgressBadge key={1} items={stageItems} />
              <FROutputCallbackBasedView step={step as FRStep} setStep={setStep}
                tree={tree} messageType={messageType} setMessageType={setMessageType}
                message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} fullWidthSave={true}
                // backLink = {<div className={ styles.backToLoginDiv}>
                //             <a className={styles.backToLogin}  onClick={()=>{window.history.go(-1)}}>{"Back to Login"}</a>
                //             </div>}
                
                /></>
            break;
            case 'SelectMFA':
                uiElement= <SelectMFAMethod step={step as FRStep} setStep={setStep}
                tree={tree} messageType={messageType} setMessageType={setMessageType}
                message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} />
                break;
              case 'RegisterApp':
                uiElement=<RegisterAppQR step={step as FRStep} setStep={setStep}
                tree={tree} messageType={messageType} setMessageType={setMessageType}
                message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} />
                break;
              case 'CheckCodeEmail':
              case 'CheckCodeApp':
                uiElement=<ValidateCode step={step as FRStep} setStep={setStep}
                tree={tree} messageType={messageType} setMessageType={setMessageType}
                message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen}/>
                 break;
        
          case 'SuspendMessage':
            sessionStorage.removeItem('mfacode');
            sessionStorage.removeItem('mfastate');
            sessionStorage.removeItem('step');
            uiElement = <SuspendMessage step={step as FRStep} />;
            break;
          case 'RedirectMFA':
            sessionStorage.setItem('step',JSON.stringify(step))
            sessionStorage.setItem('redirectOrgin',window.location.href)  
            redirectHandle(step);
            break;
          case 'ErrorInternalUser' :
            uiElement=<>
                        <FormLayout
                          header={step.getHeader()}
                          subHeader={JSON.parse(JSON.stringify(step.getCallbackOfType(CallbackType.TextOutputCallback)?.getOutputByName("message", {})))}
                          button={<></>}>
                        </FormLayout>
                      </>
        
        }
      } else if (step && step.type === StepType.LoginFailure) {
        uiElement=<> <FormLayout
        header={'Error'}
        subHeader={step.payload.message}
        button={<></>}>
        
    </FormLayout></>
        //setUpIntialStep(step.payload.message || '');
  
      }
      return uiElement;
    }
  
    const setUpIntialStep = async (message: string) => {
      //const initialStep = await FRAuth.start({ tree });
      //setStep(initialStep);
      setIsAlertOpen(true);
      setMessage(message)
  
    }
  
    //  step.getStage() returns the stage name that is defined on page nodes within the FR tree
    return (
    <>
    
      
    <div>
       <div className={LoginStyles.headerTop}>
       <a href={configOptions.lifeRayURL}><div className={LoginStyles.headerLogin}></div></a>
       </div>
       <a className={LoginStyles.backToLogin} onClick={() => {
                  // navigate("/resetpassword?goto=" + goto);
                  if (isEmpty(goto)) {
                    navigate("/login");
                  } else {
                    navigate("/login?goto=" + goto);
                  }
                }} >
          <div className={LoginStyles.backToLoginArrow} >
            <b>{" <-"}</b>
          </div >
          <div className={LoginStyles.backToLogintext} >
            Return to Login
          </div>
      </a>
      <div className="banner"  >
          <div className="leftbanner" >{" US and Non-US Persons "}</div >
          <div className="spanCenter">Technical Data<a  style={{textDecoration:'none', color:'#000'}} href="https://rtxusers.sharepoint.us/sites/enghub-PW/_layouts/15/settings.aspx">/</a>Information&nbsp;<strong>Strictly Prohibited</strong></div>
          <div className="rightbanner" >{" US and Non-US Persons "}</div >
    </div>
    </div>
        
        <main className={styles.main}>
          {getContinueRegistrationView()}
        </main>
      </>
    );
  };
  
  export default ResetPasswordPage;
  